export const languageCode = 'ko';
export const languageLabel = 'Korean';

export const translations = {
  AUDIO_DESCRIPTION_OFF: '끄기',

  CAPTIONS_BACK_TO_CAPTIONS_MENU: 'Back to captions menu',
  CAPTIONS_CAPTIONS_SETTINGS_RESET_DEFAULTS: 'Captions settings reset to defaults',
  CAPTIONS_CHARACTER_EDGE_STYLE: 'Character edge style',
  CAPTIONS_CHARACTER_EDGE_STYLE_CLOSE: 'Close character edge style menu',
  CAPTIONS_CHARACTER_EDGE_STYLE_OPEN: 'Open character edge style menu',
  CAPTIONS_CLOSE_TRANSCRIPT: 'Search Video - close transcript viewer',
  CAPTIONS_DISABLED: 'No captions available',
  CAPTIONS_FONT_FAMILY: 'Font family',
  CAPTIONS_FONT_FAMILY_CLOSE: 'Close Font Family Menu',
  CAPTIONS_FONT_FAMILY_OPEN: 'Open Font Family Menu',
  CAPTIONS_HIDE_MENU: '캡션 메뉴 숨기기',
  CAPTIONS_OFF: '끄기',
  CAPTIONS_OPEN_TRANSCRIPT: 'Search Video - open transcript viewer',
  CAPTIONS_READ_TRANSCRIPT: '동영상 검색하기',
  CAPTIONS_SHOW_MENU: '캡션 메뉴 표시',
  CAPTIONS_TURN_OFF: 'Turn off captions',
  CAPTIONS_TURN_ON: 'Turn on captions',

  CHAPTERS_CLOSE_CHAPTERS: '챕터 닫기',
  CHAPTERS_OPEN_CHAPTERS: '챕터 열기',

  CLICK_FOR_SOUND_DESKTOP_TEXT: '소리를 키려면 클릭하세요.',
  CLICK_FOR_SOUND_MOBILE_TEXT: '소리를 키려면 탭하세요.',

  CONTEXT_MENU_ABOUT_WISTIA: 'Wistia 소개',
  CONTEXT_MENU_COPIED: '복사 완료!',
  CONTEXT_MENU_COPY_LINK_AND_THUMBNAIL: '링크 및 미리보기 복사',
  CONTEXT_MENU_LOGGED_IN_TO_WISTIA: 'Wistia에 로그인 됨',
  CONTEXT_MENU_OPEN_VIDEO_IN_WISTIA: 'Wistia에서 비디오 열기',
  CONTEXT_MENU_REPORT_A_PROBLEM: '문제 보고',
  CONTEXT_MENU_VIEW_STATS_IN_WISTIA: 'Wistia에서 통계 보기',

  CUSTOMER_LOGO_LOGO: '로고',

  ENTER_PASSWORD_PHRASE: 'Please enter your password.',

  FULLSCREEN_DOUBLE_TAP: 'Double-tap to zoom in or out',
  FULLSCREEN_TITLE_WHEN_IN_FULLSCREEN: '전체화면 해제',
  FULLSCREEN_TITLE_WHEN_NOT_IN_FULLSCREEN: '전체화면',

  INCORRECT_PASSWORD: 'Incorrect Password',

  LAYOUT_TITLE: '영상',

  PASSWORD: 'Password',

  PLAY: 'Play',

  PLAY_BUTTON_LIVE_NOT_STARTED: 'Livestream has not started',
  PLAY_BUTTON_TITLE_WHEN_NOT_PLAYING: '재생',
  PLAY_BUTTON_TITLE_WHEN_PLAYING: '중지',

  REPORT_A_PROBLEM_ADD_DETAILS_TEXT: '세부사항을 추가하십시오.',
  REPORT_A_PROBLEM_CANCEL: 'Cancel',
  REPORT_A_PROBLEM_CHOOSE_ONE: '택 1',
  REPORT_A_PROBLEM_DESCRIPTION:
    '문제를 보고해 주셔서 감사합니다. 이 세션에 대한 기술 데이터를 첨부하여 문제를 파악하는 데 도움을 줍니다. 다음 중 문제를 가장 잘 설명한 것은?',
  REPORT_A_PROBLEM_DISMISS: '지우기',
  REPORT_A_PROBLEM_FAILS_TO_PLAY: '동영상 재생 실패',
  REPORT_A_PROBLEM_OTHER: '기타',
  REPORT_A_PROBLEM_OTHER_CONTEXT: '기타 세부사항 및 문제 발생 경위?',
  REPORT_A_PROBLEM_POOR_QUALITY: '동영상 품질이 좋지 않음',
  REPORT_A_PROBLEM_PROBLEM_CATEGORY: '문제 범주',
  REPORT_A_PROBLEM_PROBLEM_DESCRIPTION: '문제 설명',
  REPORT_A_PROBLEM_SELECT_CAT_TEXT: '카테고리를 선택하십시오.',
  REPORT_A_PROBLEM_SEND: '보내기',
  REPORT_A_PROBLEM_SENDING: '보내는 중...',
  REPORT_A_PROBLEM_STUTTER: '동영상은 재생되지만 자주 버벅거림',

  REWATCH: '다시보기',

  SETTINGS_PLAYBACK_RATE_TITLE: '속도',
  SETTINGS_QUALITY_AUTO: '자동',
  SETTINGS_QUALITY_TITLE: '품질',
  SETTINGS_TITLE: 'Settings',

  SHARE_CONTROL_CLOSE: '공유 메뉴 닫기',
  SHARE_CONTROL_OPEN: '공유 메뉴 열기',
  SHARE_COPIED: '복사 완료!',
  SHARE_DOWNLOAD: '다운로드',
  SHARE_EMAIL: '이메일',
  SHARE_EMBED: '임베드',
  SHARE_FACEBOOK: '페이스북',
  SHARE_LINKED_IN: '링크드인',
  SHARE_TWITTER: 'Twitter',

  SKIP: '건너뛰기',

  STATUS_BAR_EMBED_CODE_COPIED: '내장된 코드가 여러분의 클립보드에 지금 복사됩니다!',

  THUMBNAIL_VIDEO_THUMBNAIL: '영상 미리보기',

  TURNSTILE_DEFAULT_END: 'Thanks for watching! \nPlease enter your email address',
  TURNSTILE_DEFAULT_START: '이 동영상을 보려면 이메일 주소를 입력하세요.',
  TURNSTILE_EMAIL_PLACEHOLDER: '이메일',
  TURNSTILE_FIRST_NAME_PLACEHOLDER: '이름',
  TURNSTILE_LAST_NAME_PLACEHOLDER: '성',
  TURNSTILE_PLAY: '재생',
  TURNSTILE_SUBMIT: '제출',
  TURNSTILE_VENDOR_FIELD_ERROR: 'Please fill out ',

  VOLUME_TITLE_VOLUME_SLIDER: '볼륨 슬라이더',
  VOLUME_TITLE_WHEN_MUTED: '음소거 해제',
  VOLUME_TITLE_WHEN_UNMUTED: '음소거',

  WATCH_NEXT_NEXT_VIDEO_PLAYS_IN: 'The next video plays in...',
};
